import * as z from "zod";

const validationSchema = z.object({
  selectedDocuments: z.array(z.string()).default([]),
});

export const DocumentSchema = validationSchema;
export type DocumentSchemaFormInput = z.infer<typeof DocumentSchema>;
